import {
  AiOutlineFacebook,
  AiOutlineLinkedin,
  AiFillGithub,
  AiOutlineInstagram,
} from "react-icons/ai";

const data = [
  {
    id: 1,
    link: "https://www.facebook.com/masterly.chanon",
    icon: <AiOutlineFacebook />,
  },
  {
    id: 2,
    link: "https://www.instagram.com/masterlychanon",
    icon: <AiOutlineInstagram />,
  },
  {
    id: 3,
    link: "https://www.linkedin.com/in/masterlysok/",
    icon: <AiOutlineLinkedin />,
  },
  { id: 4, link: "https://github.com/Masterly0607", icon: <AiFillGithub /> },
];

export default data;
